import { FormArray, FormGroup } from "@angular/forms";

type ErrorMap = Record<string, unknown>;
type ErrorArrayMap = Record<string, unknown[]>;

function ScrollToError(error: ErrorMap, errorArray: ErrorArrayMap): void {
  let el: Element | null = null;

  Object.keys(errorArray).forEach((k) => {
    if (errorArray[k].length === 0) {
      delete errorArray[k];
    }
  });

  const errorKeys = Object.keys(error);
  if (errorKeys.length === 0) {
    return;
  }

  const key = errorKeys[0];
  const errorValue = error[key];
  if (!Array.isArray(errorValue)) {
    el = document.querySelector("[name=" + key + "]");
  } else {
    const errorArrayKeys = Object.keys(errorArray);
    if (errorArrayKeys.length === 0) {
      return;
    }

    const k = errorArrayKeys[0];
    const fieldErrors = error[k];

    if (!Array.isArray(fieldErrors)) {
      return;
    }

    for (let i = 0; i <= fieldErrors.length; i++) {
      const itemError = errorValue[i];
      if (
        itemError !== null &&
        typeof itemError === "object" &&
        !Array.isArray(itemError) &&
        Object.keys(itemError).length > 0
      ) {
        el = document.querySelector(
          "[name=" +
            k +
            "_" +
            Object.keys(fieldErrors)[i] +
            "_" +
            Object.keys(itemError)[0] +
            "]"
        );
        // if (!el) {
        //   el = document.querySelector('#' + k + '_' + Object.keys(error[k])[i] + '_' + Object.keys(error[k][i])[0]);
        // }
        break;
      }
    }
  }
  setTimeout(() => {
    if (el !== null) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, 200);
}

export function SetError(
  form: FormGroup,
  apiError?: Record<string, unknown[]>
): ErrorMap {
  const error: ErrorMap = {};
  const errorArray: ErrorArrayMap = {};

  if (apiError !== undefined) {
    Object.keys(apiError).forEach((k) => {
      error[k] = apiError[k][0];
    });
  } else {
    Object.keys(form.value).forEach((k) => {
      const object = form.controls[k];
      if (object instanceof FormArray) {
        // error[k] = SetErrorArray(object);
        // errorArray[k] = QueryErrorArray(object);
      } else {
        if (object.errors !== null) {
          error[k] = object.errors;
        }
      }
    });
    ScrollToError(error, errorArray);
  }
  // Scroll to error element

  return error;
}

function SetErrorArray(form: FormArray): unknown[] {
  const errors: unknown[] = [];

  // form.controls.forEach(
  //   (control: AbstractControl, index: number, array: AbstractControl[]) => {
  //     const error = {};
  //     Object.keys(control.value).forEach((key) => {
  //       if (control.controls[key].errors) {
  //         error[key] = control.controls[key].errors;
  //       }
  //     });
  //     errors.push(error);
  //   }
  // );

  return errors;
}

function QueryErrorArray(form: FormArray): unknown[] {
  const errors: unknown[] = [];

  // form.controls.forEach((control: FormGroup) => {
  //   const error = {};
  //   Object.keys(control.value).forEach((key, index) => {
  //     if (control.controls[key].errors) {
  //       error[key] = control.controls[key].errors;
  //       errors.push(error);
  //     }
  //   });
  // });

  return errors;
}
